import type { EmptyStateHeadingLevel, EmptyStateTone } from './EmptyState.types'

/** Nivel de encabezado por defecto del título: `<h2>`. */
export const DEFAULT_TITLE_LEVEL: EmptyStateHeadingLevel = 2

/** Tono por defecto: neutro (icono en color de texto secundario). */
export const DEFAULT_TONE: EmptyStateTone = 'neutral'

/** Tamaño en px del icono/ilustración por defecto. */
export const DEFAULT_ICON_SIZE = 48
